import { gql } from "@apollo/client";

export const GET_MOTIVOS_DEMORA = gql`
query allMotivoDemora{
    allMotivoDemora {
        idMotivoDemora,
        motivoDemora
    }
  }
`;

export const adaptMotivoDemora = (motivo) => ({
  id: motivo.idMotivoDemora,
  displayName: motivo.motivoDemora
});

export const adaptMotivoDemoraArray = (motivos) =>
structuredClone(motivos?.allMotivoDemora)?.
map((motivo) => adaptMotivoDemora(motivo));